/**
 * @generated SignedSource<<37eedb4c68ce1580f6cef0633fa036e2>>
 * @relayHash c03316391fcc9c853461d265ce370b4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 954cd8014c6667db8dfeabe0dbb8084e387672be98473a739e6aefe7bf974db7

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type uiIssueRealtimeUpdatesIssueDeletedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type uiIssueRealtimeUpdatesIssueDeletedSubscription$data = {
  readonly jira: {
    readonly onIssueDeletedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type uiIssueRealtimeUpdatesIssueDeletedSubscription = {
  response: uiIssueRealtimeUpdatesIssueDeletedSubscription$data;
  variables: uiIssueRealtimeUpdatesIssueDeletedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueDeletedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueDeletedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "uiIssueRealtimeUpdatesIssueDeletedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uiIssueRealtimeUpdatesIssueDeletedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "954cd8014c6667db8dfeabe0dbb8084e387672be98473a739e6aefe7bf974db7",
    "metadata": {},
    "name": "uiIssueRealtimeUpdatesIssueDeletedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "73b9cffda1adc0458893b4034d1df6c6";

export default node;
